<h1 mat-dialog-title>組織情報</h1>

<div mat-dialog-content>
  <form (ngSubmit)="onSubmit()" class="team-form" #teamForm="ngForm">
    <mat-form-field>
      <input matInput placeholder="組織名" id="teamName" [(ngModel)]="keySet.name" name="teamName" #teamName="ngModel"
        required>
      <mat-error *ngIf="teamName.errors?.required">組織名の入力は必須です</mat-error>
    </mat-form-field>
    <span>
      <button  type="button" mat-raised-button (click)="onCancel()">キャンセル</button>
      <button type="submit" mat-raised-button color="primary" [disabled]="teamForm.invalid || submitting">登録</button>
    </span>
  </form>
</div>
